import {useState} from "react";
export default function useShowHidePassword(){
    const [currentValue,setCurrentValue] = useState({check:false,inputType:"password"});
    const setShowHidePassword = ()=>{
        if(currentValue.check){
            setCurrentValue({check:false,inputType:"password"});
        } else {
            setCurrentValue({check:true,inputType:"text"});
        }
    }
    return [currentValue,setShowHidePassword];
}
